<template>
  <div>
    <van-search v-model="query" placeholder="请输入搜索内容" class="search" />
    <div class="container">
      <div class="left">
        <div
          v-for="(item, index) in typeList"
          :key="index"
          @click="changeType(index)"
          class="left-item"
          :style="
            index == activeKey
              ? { color: '#ffffff', 'background-color': '#2B71FE' }
              : {}
          "
        >
          <p>{{ item.type_name }}</p>
        </div>
      </div>
      <div class="right">
        <div v-if="typeList[activeKey]">
          <div
            v-for="(item, index) in typeList[activeKey].questions"
            :key="index"
          >
            <p class="right-title">{{ item.title }}</p>
            <p class="right-content" v-html="dealContent(item.content)" @click.prevent="jumpOut">
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getFaqByType, faqCatalog } from '@/api/problem'
export default {
  data() {
    return {
      query: '',
      activeKey: '0',
      typeList: [],
    }
  },
  created() {
    this.getList()
  },
  watch: {
    query(news, old) {
      clearTimeout(this.timeOut)
      this.timeOut = setTimeout(() => {
        this.list = []
        this.getList(this.activeKey)
      }, 1000)
    },
  },
  mounted(){
    this.pageEnterTime = new Date().getTime();
  },
  beforeDestroy(){
    var pageLeaveTime = new Date().getTime();
    var stayDuration = pageLeaveTime - this.pageEnterTime;
    window._hmt && _hmt.push(['_trackEvent', 'FAQ页面停留时间', 'stay', '/problem', stayDuration]);
  },
  computed: {
    dealContent(){
      return (content) => {
        if (content) {
          return content.replaceAll('src="../..',`src="${process.env.VUE_APP_API_ORIGIN}`)
          // return content.replaceAll('background-color: #ffffff', "").replaceAll('src="../..',`src="${process.env.VUE_APP_API_ORIGIN}`)
        }else{
          return ''
        }
      }
    }
  },
  methods: {
    jumpOut(event){
      this.$utils.app.openUrl(event.target.href)
    },
    changeType(index) {
      this.activeKey = index
      // 根据类型获取内容
      getFaqByType({ type: this.typeList[index].type }).then((res) => {
        this.typeList[index].questions.forEach((item) => {
          // 内容与标题进行匹配
          let found = res.find((t) => {
            return t.id == item.id
          })
          this.$set(item, 'content', found.content)
        })
        // 如果存在筛选条件则进行过滤
        if (this.query) {
          this.typeList.forEach(item => {
            let arr = item.questions.filter(t => t.is_search == 1)
            item.questions = arr
          });
        }

      })
    },
    getList(index=0) {
      if(this.query){
        window._hmt && _hmt.push(['_trackEvent', 'FAQ页面 搜索', 'click', JSON.stringify(this.user)+','+this.query]);
      }
      // 获取类型列表
      faqCatalog({ search: this.query }).then((res) => {
        this.typeList = res
        if (this.typeList[index]) {
          this.changeType(index)
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.search {
  width: 996px;
  margin-left: 65px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.5);
  padding: 2px;
}
::v-deep .van-icon {
  font-size: 50px !important;
}
::v-deep.van-search__content {
  background-color: rgba(0, 0, 0, 0);
}
::v-deep input::placeholder {
  color: #707070;
  font-size: 42px;
}
.container {
  ::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  width: 996px;
  height: 72vh;
  background-color: rgba(137, 137, 137, 0.1);
  margin-left: 64px;
  margin-top: 31px;
  border-radius: 5px;
  overflow: hidden;
  .left {
    width: 200px;
    background-color: rgba(137, 137, 137, 0.1);
    height: 100%;
    display: inline-block;
    overflow-y: scroll;
    &-item {
      min-height: 126px;
      width: 100%;
      font-size: 30px;
      color: #000000;
      font-weight: 400;
      display: flex;
      align-items: center;
      padding: 0 24px;
      text-align: center;
    }
  }
  .right {
    display: inline-block;
    vertical-align: top;
    padding: 50px 56px 0 54px;
    width: 796px;
    height: 100%;
    overflow-y: scroll;
    &-title {
      color: #2b71fe;
      font-size: 40px;
      font-weight: 500;
    }
    &-content {
      color: #313131;
      font-size: 32px;
      font-weight: 400;
      margin-top: 42px;
      margin-bottom: 93px;
      margin-left: 36px;
      // text-indent: 2em;
    }
  }
}
</style>
